import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { MdOutlineFileUpload } from "react-icons/md";
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";

const WarehouseLane = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-n");
    const [overlyBlock, setOverlyBlock] = useState("show-n");
    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");
    const [rowData, setRowData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    
    // Confirmation alert states
    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmTitle, setConfirmTitle] = useState("");
    const [confirmType, setConfirmType] = useState("default");
    const [confirmCallback, setConfirmCallback] = useState(null);
    
    // Slider states
    const [isSliderOpen, setSliderOpen] = useState(false);
    const [sliderType, setSliderType] = useState(null);
    const [sliderCl, setSliderCl] = useState("");
    const [sliderTitle, setSliderTitle] = useState("");
    const [uploadedFileData, setUploadedFileData] = useState([]);
    const [file, setFile] = useState(null);
    const editFormRef = useRef(null);

    // Add this useEffect to reset scroll position when slider opens
    useEffect(() => {
        if (sliderType === 3 && isSliderOpen && editFormRef.current) {
            // Reset scroll position to top when edit slider opens
            editFormRef.current.scrollTop = 0;
        }
    }, [sliderType, isSliderOpen]);
    
    // Edit states
    const [editFormData, setEditFormData] = useState({
        sku_code: "",
        source_name: "",
        destination_store_name: "",
        transit_days: "",
        packaging_days: "",
        qc_hold_days: "",
        norm_days: "",
        production_cycle_days: "",
        replenishment_cycle_days: "",
        is_active: ""  // Added is_active field
    });

    const [duplicatedEditData, setDuplicatedEditData] = useState({
        transit_days: "",
        packaging_days: "",
        qc_hold_days: "",
        norm_days: "",
        production_cycle_days: "",
        replenishment_cycle_days: "",
        is_active: ""  // Added is_active field
    });

    // Status options for is_active dropdown
    const statusOptions = [
        { label: "Active", value: 1 },
        { label: "In-Active", value: 0 }
    ];

    // Filter states
    const [destination, setDestination] = useState({ label: "ALL", value: "" });
    const [destinationOptions, setDestinationOptions] = useState([{ label: "ALL", value: "" }]);

    const gridApi = useRef(null);
    const gridColumnApi = useRef(null);

    // Selection column for checkbox
    const selectionColumn = {
        headerName: "",
        field: "selection",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        maxWidth: 50,
        pinned: 'left',
        suppressMenu: true,
        suppressSorting: true,
        filter: false,
        // resizable: false,
    };

    // Action column for edit
    const actionColumn = {
        headerName: "",
        field: "actions",
        sortable: false,
        filter: false,
        width: 90,
        pinned: 'left',
        cellClass: "custom-cell", 
        cellRendererFramework: (params) => {
            return (
                <div style={{ height: "36px", padding: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <button
                        title="Edit"
                        className="mt-2"
                        style={{
                            height: "30px", 
                            width: "60px",
                            padding: "0 10px",
                            border: "1px solid #93385D",
                            borderRadius: "4px",
                            backgroundColor: "#F4EBEF",
                            fontSize: "0.8rem",
                            color: "#93385D",
                            cursor: "pointer"
                        }}
                        onClick={() => handleEdit(params.data)}
                    >
                        Edit
                    </button>
                </div>
            )
        },
    };

    const columnWithDefs = [
        selectionColumn, // Add selection column first
        actionColumn,
        {
            headerName: "SKU Code",
            field: "sku_code",
            tooltipField: "sku_code",
            sortable: true,
            resizable: true,
            width: 120,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "Source Name",
            field: "source_name",
            tooltipField: "source_name",
            sortable: true,
            resizable: true,
            width: 150,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "source Id",
            field: "source_id",
            tooltipField: "source_id",
            sortable: true,
            resizable: true,
            width: 180,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },    
        {
            headerName: "Sku Category",
            field: "sku_category",
            tooltipField: "sku_category",
            sortable: true,
            resizable: true,
            width: 180,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "Destination Store Name",
            field: "destination_store_name",
            tooltipField: "destination_store_name",
            sortable: true,
            resizable: true,
            width: 180,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "Destination Store Id",
            field: "destination_store_id",
            tooltipField: "destination_store_id",
            sortable: true,
            resizable: true,
            width: 180,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "Transit Days",
            field: "transit_days",
            tooltipField: "transit_days",
            sortable: true,
            resizable: true,
            width: 120,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "Packaging Days",
            field: "packaging_days",
            tooltipField: "packaging_days",
            sortable: true,
            resizable: true,
            width: 140,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "QC Hold Days",
            field: "qc_hold_days",
            tooltipField: "qc_hold_days",
            sortable: true,
            resizable: true,
            width: 130,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "Production Cycle Days",
            field: "production_cycle_days",
            tooltipField: "production_cycle_days",
            sortable: true,
            resizable: true,
            width: 180,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
            headerName: "Replenishment Cycle Days",
            field: "replenishment_cycle_days",
            tooltipField: "replenishment_cycle_days",
            sortable: true,
            resizable: true,
            width: 200,
            cellStyle: (params) => {
                if (params.data && params.data.is_active === 0) {
                    return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
                }
                return null;
            },
        },
        {
        headerName: "Norm Days",
        field: "norm_days",
        tooltipField: "norm_days",
        sortable: true,
        resizable: true,
        width: 130,
        cellStyle: (params) => {
            if (params.data && params.data.is_active === 0) {
                return {
                    backgroundColor: "#da86a7ff",
                    color: "white",
                    fontWeight: "bold"
                };
            }
            return null;
        },
    },
        {
            headerName: "Status",
            field: "is_active",
            tooltipField: "is_active",
            sortable: true,
            resizable: true,
            width: 120,
            valueGetter: (params) => {
                const { is_active } = params.data;
                return is_active === 0 ? "In - Active" : "Active";
            },
            cellStyle: (params) => {
                if (params.node.rowPinned === "bottom") {
                    return { fontWeight: "bold", backgroundColor: "#f5f5f5ff" };
                }
                if (params.value === "In - Active") {
                    return {
                        backgroundColor: "#da86a7ff",
                        color: "white",
                        fontWeight: "bold",
                    };
                }
                return null;
            },
        }
    ];

    // Handle row selection
    const onSelectionChanged = () => {
        if (gridApi.current) {
            const selectedNodes = gridApi.current.getSelectedNodes();
            const selectedData = selectedNodes.map(node => node.data);
            setSelectedRows(selectedData);
        }
    };

    // Show confirmation dialog
    const showConfirmation = (title, type, onConfirm) => {
        setConfirmTitle(title);
        setConfirmType(type);
        setConfirmCallback(() => onConfirm);
        setShowConfirm(true);
    };

    // Handle confirmation
    const handleConfirm = () => {
        if (confirmCallback) {
            confirmCallback();
        }
        setShowConfirm(false);
        setConfirmCallback(null);
    };

    // Cancel confirmation
    const handleCancel = () => {
        setShowConfirm(false);
        setConfirmCallback(null);
    };

        const updateBulkStatus = async (newStatus) => {
            if (selectedRows.length === 0) {
                setShow(true);
                setBasicType("info");
                setBasicTitle("Please select at least one row to update");
                return;
            }

            const allInActive = selectedRows.every(row => row.is_active === 0);
            const allActive = selectedRows.every(row => row.is_active === 1);
            
            if (!allInActive && !allActive) {
                setShow(true);
                setBasicType("warning");
                setBasicTitle("Please select rows with the same status (all Active or all In-Active)");
                return;
            }

            if (newStatus === 1 && !allInActive) {
                setShow(true);
                setBasicType("warning");
                setBasicTitle("Can only activate In-Active items. Please select only In-Active rows.");
                return;
            }
            
            if (newStatus === 0 && !allActive) {
                setShow(true);
                setBasicType("warning");
                setBasicTitle("Can only inactivate Active items. Please select only Active rows.");
                return;
            }

            const statusText = newStatus === 1 ? "Active" : "In-Active";
            const confirmMessage = `Are you sure you want to mark ${selectedRows.length} selected item(s) as ${statusText}?`;
            
            showConfirmation(confirmMessage, "warning", async () => {
                setLoadshow("show-m");
                setOverlayBlock("show-m");

                try {
                    const ids = selectedRows.map(row => row._id);
                    
                    const response = await redirectURL.post("indentation/bulkUpdateWarehouseLaneStatus", {
                        ids: ids,
                        is_active: newStatus
                    });

                    if (response.data.status === "success") {
                        await getWarehouseLaneData();
                        setSelectedRows([]);
                        if (gridApi.current) {
                            gridApi.current.deselectAll();
                        }
                        setShow(true);
                        setBasicType("success");
                        setBasicTitle(`Successfully updated ${response.data.data.modifiedCount} item(s) to ${statusText}`);
                    } else {
                        setShow(true);
                        setBasicType("error");
                        setBasicTitle(response.data.message || "Failed to update status");
                    }
                } catch (error) {
                    console.error("Error updating bulk status:", error);
                    setShow(true);
                    setBasicType("error");
                    setBasicTitle("Failed to update status");
                } finally {
                    setLoadshow("show-n");
                    setOverlayBlock("show-n");
                }
            });
        };

    const handleEdit = (rowData) => {
        setEditFormData({
            _id: rowData._id,
            sku_code: rowData.sku_code || "",
            source_name: rowData.source_name || "",
            destination_store_name: rowData.destination_store_name || "",
            transit_days: rowData.transit_days !== undefined && rowData.transit_days !== null ? rowData.transit_days : "",
            packaging_days: rowData.packaging_days !== undefined && rowData.packaging_days !== null ? rowData.packaging_days : "",
            qc_hold_days: rowData.qc_hold_days !== undefined && rowData.qc_hold_days !== null ? rowData.qc_hold_days : "",
            norm_days: rowData.norm_days !== undefined && rowData.norm_days !== null ? rowData.norm_days : "",
            production_cycle_days: rowData.production_cycle_days !== undefined && rowData.production_cycle_days !== null ? rowData.production_cycle_days : "",
            replenishment_cycle_days: rowData.replenishment_cycle_days !== undefined && rowData.replenishment_cycle_days !== null ? rowData.replenishment_cycle_days : "",
            is_active: rowData.is_active !== undefined && rowData.is_active !== null ? rowData.is_active : 1
        });
        
        setDuplicatedEditData({
            transit_days: rowData.transit_days !== undefined && rowData.transit_days !== null ? rowData.transit_days : "",
            packaging_days: rowData.packaging_days !== undefined && rowData.packaging_days !== null ? rowData.packaging_days : "",
            qc_hold_days: rowData.qc_hold_days !== undefined && rowData.qc_hold_days !== null ? rowData.qc_hold_days : "",
            norm_days: rowData.norm_days !== undefined && rowData.norm_days !== null ? rowData.norm_days : "",
            production_cycle_days: rowData.production_cycle_days !== undefined && rowData.production_cycle_days !== null ? rowData.production_cycle_days : "",
            replenishment_cycle_days: rowData.replenishment_cycle_days !== undefined && rowData.replenishment_cycle_days !== null ? rowData.replenishment_cycle_days : "",
            is_active: rowData.is_active !== undefined && rowData.is_active !== null ? rowData.is_active : 1
        });

        setSliderOpen(true);
        setSliderType(3);
        setSliderCl("slider-25");
        setSliderTitle(`Edit Warehouse Lane - ${rowData.sku_code}`);
        setOverlyBlock("show-m");
    };

    const handleEditInputChange = (field, value) => {
        setEditFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setEditFormData(prev => ({
            ...prev,
            is_active: selectedOption ? selectedOption.value : 1
        }));
    };

    const onClickingUpdateWarehouseLane = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");  
        
        const isNeedtoUpdate = Object.keys(duplicatedEditData).some(
            (key) => duplicatedEditData[key] !== editFormData[key]
        );

        if (!isNeedtoUpdate) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("No changes made to warehouse lane data");
            setLoadshow("show-n");
            setOverlayBlock("show-n");
            return;
        }

        try {
            const response = await redirectURL.post("indentation/updateWarehouseLane", {
                id: editFormData._id,
                transit_days: editFormData.transit_days,
                packaging_days: editFormData.packaging_days,
                norm_days: editFormData.norm_days,
                qc_hold_days: editFormData.qc_hold_days,
                production_cycle_days: editFormData.production_cycle_days,
                replenishment_cycle_days: editFormData.replenishment_cycle_days,
                is_active: editFormData.is_active
            });

            if (response.data.status === "success") {
                await getWarehouseLaneData();
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("success");
                setBasicTitle("Warehouse lane data updated successfully");
                hideOverlySlideBlock();
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("info");
                setBasicTitle(response.data.message || "Failed to update warehouse lane data");
            }
        } catch (error) {
            console.error("Error updating warehouse lane:", error);
            setShow(true);
            setBasicType("info");
            setBasicTitle("Failed to update warehouse lane data");
        }
    };

    // Upload functionality
    const downloadExcelTemplate = () => {
        const sampleData = [
            ["sku_code", "source_name", "destination_name", "transit_days", "packaging_days", "production_cycle_days", "replenishment_cycle_days", "qc_hold_days","norm_days"],
        ];

        const ws = utils.aoa_to_sheet(sampleData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "WarehouseLaneTemplate");
        writeFile(wb, "warehouse_lane_template.xlsx");
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFile(e.target.value);
        
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            
            const parsedData = XLSX.utils.sheet_to_json(worksheet, {
                raw: false,
                dateNF: "yyyy-mm-dd",
            });

            const mapping = {
                "sku_code": "sku_code",
                "source_name": "source_name",
                "destination_name": "destination_store_name",
                "transit_days": "transit_days",
                "packaging_days": "packaging_days",
                "production_cycle_days": "production_cycle_days",
                "replenishment_cycle_days": "replenishment_cycle_days",
                "qc_hold_days": "qc_hold_days",
                "norm_days": "norm_days"
            };

            function toSnakeCase(str) {
                return str
                    .trim()
                    .replace(/\s+/g, '_')
                    .replace(/[A-Z]/g, letter => letter.toLowerCase())
                    .replace(/[^a-z0-9_]/g, '');
            }

            const result = parsedData.map(item => {
                const newItem = {};
                for (const key in item) {
                    if (mapping[key]) {
                        newItem[mapping[key]] = item[key];
                    } else {
                        newItem[toSnakeCase(key)] = item[key];
                    }
                }
                // Set default is_active to 1 (Active) for new uploads
                return newItem;
            });
            console.log(result,"results");

            setUploadedFileData(result);
        };
        reader.readAsArrayBuffer(file);
    };

    const onClickingFileSubmit = async () => {
        if (uploadedFileData.length === 0) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("Please upload a valid file");
            return;
        }

        const params = { data: uploadedFileData };
        
        try {
            const response = await redirectURL.post(
                "indentation/UploadWarehouseLaneData",
                params
            );
            
            // Parse the nested response to check actual status
            let actualStatus = "success";
            let actualMessage = response.data.message;
            
            try {
                const parsedResponse = JSON.parse(response.data.response);
                if (parsedResponse.status === "Failure") {
                    actualStatus = "failure";
                    actualMessage = parsedResponse.message;
                }
            } catch (parseError) {
                console.warn("Could not parse nested response:", parseError);
            }
            
            if (actualStatus === "success") {
                const backendMessage = actualMessage || "Warehouse lane data uploaded successfully";
                
                setUploadedFileData([]);
                await getWarehouseLaneData();
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("success");
                setBasicTitle(backendMessage);
                hideOverlySlideBlock();
                
                // User Action Triggering
                const userData = {
                    email: localStorage.getItem("email"),
                    user_code: localStorage.getItem("user_code"),
                    action: "Bulk Uploaded Warehouse Lane Data",
                    status: "Success",
                    path: window.location.pathname
                };
                triggerUserAction(userData);
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("error");
                setBasicTitle(actualMessage || "Data upload failed");
                
                const userData = {
                    email: localStorage.getItem("email"),
                    user_code: localStorage.getItem("user_code"),
                    action: "Bulk Uploaded Warehouse Lane Data",
                    status: "Failure",
                    path: window.location.pathname
                };
                triggerUserAction(userData);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred";
            setUploadedFileData([]);
            setShow(true);
            setBasicType("error");
            setBasicTitle(errorMessage);
            
            const userData = {
                email: localStorage.getItem("email"),
                user_code: localStorage.getItem("user_code"),
                action: "Bulk Uploaded Warehouse Lane Data",
                status: "Failure",
                path: window.location.pathname
            };
            triggerUserAction(userData);
        }
    };

    const onClickUploadWarehouseLaneData = () => {
        setUploadedFileData([]);
        setSliderOpen(true);
        setSliderType(2);
        setSliderCl("slider-25");
        setSliderTitle("Upload Warehouse Lane Data");
        setOverlyBlock("show-m");
    };

    const resetFormData = () => {
        setEditFormData({
            sku_code: "",
            source_name: "",
            destination_store_name: "",
            transit_days: "",
            packaging_days: "",
            qc_hold_days: "",
            production_cycle_days: "",
            replenishment_cycle_days: "",
            is_active: ""
        });
        setDuplicatedEditData({
            transit_days: "",
            packaging_days: "",
            qc_hold_days: "",
            production_cycle_days: "",
            replenishment_cycle_days: "",
            is_active: ""
        });
    };

    const hideOverlySlideBlock = () => {
        setOverlyBlock("show-n");
        setLoadshow("show-n");
        setSliderOpen(false);
        resetFormData();
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
        setUploadedFileData([]);
        setFile(null);
    };

    const onClickingSliderCloseIcon = () => {
        setOverlyBlock("show-n");
        setSliderOpen(false);
        resetFormData();
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
        setUploadedFileData([]);
        setFile(null);
    };

    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ]
    }), []);

    const statusPanel = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    };

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 150,
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
        gridColumnApi.current = params.columnApi;

        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    const onFirstDataRendered = (params) => {
        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    const getWarehouseLaneData = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");
            const response = await redirectURL.post("indentation/getWarehouseLaneData", {});

            if (response.status === 200) {
                if (response.data.status === "success" && response.data.data && response.data.data.length > 0) {
                    const data = response.data.data;
                    setRowData(data);
                    setFilteredData(data);
                    getDestinationOptions(data);
                } else {
                    setBasicTitle(response.data.message || "No warehouse lane data found");
                    setBasicType("info");
                    setShow(true);
                }
            }
        } catch (error) {
            console.error("Error fetching warehouse lane data:", error);
            setBasicTitle("Failed to fetch warehouse lane data");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const getDestinationOptions = (data) => {
        try {
            const destinationsMap = new Map();
            data.forEach(item => {
                if (item.destination_store_id && item.destination_store_name) {
                    const key = `${item.destination_store_id}-${item.destination_store_name}`;
                    if (!destinationsMap.has(key)) {
                        destinationsMap.set(key, {
                            destination_store_id: item.destination_store_id,
                            destination_store_name: item.destination_store_name
                        });
                    }
                }
            });

            const destinations = Array.from(destinationsMap.values());
            const options = [
                { label: "ALL", value: "" },
                ...destinations.map(dest => ({
                    value: dest.destination_store_id,
                    label: `${dest.destination_store_id} - ${dest.destination_store_name}`
                }))
            ];

            setDestinationOptions(options);
            setDestination(options[0]);
        } catch (error) {
            console.error("Error processing destination options:", error);
            setDestinationOptions([{ label: "ALL", value: "" }]);
        }
    };

    const applyFilters = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            if (!destination.value) {
                setFilteredData(rowData);
            } else {
                const filtered = rowData.filter(
                    (item) => item.destination_store_id === destination.value
                );
                setFilteredData(filtered);
            }
            
            // Clear selection when filter changes
            setSelectedRows([]);
            if (gridApi.current) {
                gridApi.current.deselectAll();
            }
        } catch (error) {
            console.error("Error applying filters:", error);
            setBasicTitle("Failed to apply filters");
            setBasicType("error");
            setShow(true);
        } finally {
            setTimeout(() => {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
            }, 400);
        }
    };

    const resetFilters = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            setDestination({ label: "ALL", value: "" });
            setFilteredData(rowData);
            
            // Clear selection when resetting filters
            setSelectedRows([]);
            if (gridApi.current) {
                gridApi.current.deselectAll();
            }
        } catch (error) {
            console.error("Error resetting filters:", error);
        } finally {
            setTimeout(() => {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
            }, 400);
        }
    };

    useEffect(() => {
        const getData = async () => {
            await getWarehouseLaneData();
        };
        getData();
    }, []);

    const closeAlert = () => {
        setShow(false);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setOverlyBlock("show-n");
        setSliderOpen(false);
        resetFormData();
        setUploadedFileData([]);
        setFile(null);
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
    };

    // User Action Triggering
    const triggerUserAction = (trigerdata) => {
        redirectURL.post('inventory/triggerUserAction', trigerdata)
    };


    const onBulkDelete = () => {
  if (selectedRows.length === 0) {
    setShow(true);
    setBasicType("info");
    setBasicTitle("Please select at least one row to delete");
    return;
  }

  const confirmMessage = `Are you sure you want to delete ${selectedRows.length} selected item(s)? This action cannot be undone.`;

  showConfirmation(confirmMessage, "warning", async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const ids = selectedRows.map(r => r._id);

      const response = await redirectURL.post("indentation/bulkDeleteWarehouseLane", {
        ids
      });

      if (response.data.status === "success") {
        await getWarehouseLaneData();
        setSelectedRows([]);
        if (gridApi.current) gridApi.current.deselectAll();

        setShow(true);
        setBasicType("success");
        setBasicTitle(`Deleted ${response.data.data.deletedCount} item(s) successfully`);
      } else {
        setShow(true);
        setBasicType("error");
        setBasicTitle(response.data.message || "Failed to delete");
      }
    } catch (err) {
      console.error("Bulk delete error:", err);
      setShow(true);
      setBasicType("error");
      setBasicTitle("Failed to delete");
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  });
};
    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    {/* Regular Alert */}
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    />
                    
                    {/* Confirmation Alert */}
                    <SweetAlert
                        show={showConfirm}
                        type={confirmType}
                        title={confirmTitle}
                        showCancel
                        confirmBtnText="Yes, proceed"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        onConfirm={handleConfirm}
                        onCancel={handleCancel}
                        style={{ fontSize: "9px" }}
                    />
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
                    <form className="col-sm-12 p-0 mb-4" style={{ display: "flex", alignItems: "center" }}>
                        <div className="col-sm-8 row">
                            <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="destination" style={{ fontSize: '13px', fontWeight: '400' }}>
                                    Destination Store:
                                </label>
                                <Select
                                    id="destination"
                                    value={destination}
                                    onChange={(selectedOption) => setDestination(selectedOption)}
                                    options={destinationOptions}
                                    styles={selectStyles}
                                />
                            </div>

                            <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                                <button
                                    type="button"
                                    onClick={(e) => { e.preventDefault(); applyFilters(); }}
                                    style={{
                                        backgroundColor: "#93385D",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "none",
                                        cursor: "pointer"
                                    }}
                                >
                                    Apply
                                </button>
                                <button
                                    onClick={(e) => { e.preventDefault(); resetFilters(); }}
                                    type="button"
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "1px solid #d9d9d9",
                                        cursor: "pointer"
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

{/* Action Buttons */}
<div className="col-sm-4" style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
    {selectedRows.length > 0 && (
        <>
            {selectedRows.every(row => row.is_active === 0) && (
                <button
                    type="button"
                    onClick={() => updateBulkStatus(1)}
                    style={{
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        borderRadius: "5px",
                        padding: "8px 20px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        fontWeight: "bold",
                    }}
                >
                    Active({selectedRows.length})
                </button>
            )}
            
            {selectedRows.every(row => row.is_active === 1) && (
                <button
                    type="button"
                    onClick={() => updateBulkStatus(0)}
                    style={{
                        backgroundColor: "#f44336",
                        color: "#fff",
                        borderRadius: "5px",
                        padding: "8px 20px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        fontWeight: "bold",
                    }}
                >
                    In-Active({selectedRows.length})
                </button>
            )}
            
            {!selectedRows.every(row => row.is_active === 0) && 
             !selectedRows.every(row => row.is_active === 1) && (
                <div style={{
                    color: "#da5353",
                    fontSize: "15px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    marginBottom: " 2px 5px",
                    padding: "8px 0",
                    fontStyle: "italic"
                }}>
                    Select rows with same status
                </div>
            )}
            {selectedRows.length > 0 && (
  <button
    type="button"
    onClick={() => onBulkDelete()}
    style={{
      backgroundColor: "#93385D",
      color: "#fff",
      borderRadius: "5px",
      padding: "8px 20px",
      border: "none",
      cursor: "pointer",
      fontSize: "0.8rem",
      fontWeight: "bold",
    }}
  >
    Delete({selectedRows.length})
  </button>
)}
        </>
    )}
    
    <button
        type="button"
        onClick={onClickUploadWarehouseLaneData}
        className="mr-2"
        style={{
            ...addButtonStyle,
            backgroundColor: "#F4EBEF",
            color: "#93385D",
            border: "2px solid #93385D",
        }}
    >
        <MdOutlineFileUpload style={{ color: "#93385D", fontSize: "20px" }} />
        &nbsp;
        Upload Warehouse Lane
    </button>
</div>
                    </form>

                    {/* Data Grid */}
                    <div className="col-sm-12 p-0 pl-2 mt-6">
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: 'calc(100vh - 250px)',
                                width: "100%",
                                minHeight: '400px'
                            }}
                        >
                            <AgGridReact
                                rowData={filteredData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                                sideBar={sideBar}
                                statusBar={statusPanel}
                                rowSelection="multiple"
                                onSelectionChanged={onSelectionChanged}
                                suppressRowClickSelection={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Slider */}
            <div className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`} style={{ width: "25%" }}>
                <div className="slider-header-container d-flex justify-content-between">
                    <p className="m-0p">{sliderTitle}</p>
                    <p
                        className="m-0p"
                        style={{ cursor: "pointer" }}
                        onClick={onClickingSliderCloseIcon}
                    >
                        X&nbsp;&nbsp;&nbsp;
                    </p>
                </div>

                {sliderType === 3 && (
                    <form 
                        ref={editFormRef}
                        style={{ 
                            padding: "20px",
                            height: "calc(100vh - 80px)",
                            overflowY: "auto",
                            overflowX: "hidden"
                        }}
                        onSubmit={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onClickingUpdateWarehouseLane();  
                        }}
                    >
                        {/* Display Only Fields */}
                        <div className="form-group">
                            <label htmlFor="sku_code" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>SKU Code</label>
                            <input
                                type="text"
                                className="form-control"
                                id="sku_code"
                                name="sku_code"
                                value={editFormData.sku_code}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                    backgroundColor: "#f9f9f9",
                                    cursor: "not-allowed",
                                }}
                                disabled 
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="source_name" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>Source Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="source_name"
                                name="source_name"
                                value={editFormData.source_name}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                    backgroundColor: "#f9f9f9",
                                    cursor: "not-allowed",
                                }}
                                disabled 
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="destination_store_name" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>Destination Store Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="destination_store_name"
                                name="destination_store_name"
                                value={editFormData.destination_store_name}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                    backgroundColor: "#f9f9f9",
                                    cursor: "not-allowed",
                                }}
                                disabled 
                            />
                        </div>

                        {/* Status Dropdown - New Field */}
                        <div className="form-group">
                            <label htmlFor="is_active" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>Status <span style={{color: "red"}}>*</span></label>
                            <Select
                                id="is_active"
                                value={statusOptions.find(option => option.value === editFormData.is_active)}
                                onChange={handleStatusChange}
                                options={statusOptions}
                                styles={selectStyles}
                                placeholder="Select Status"
                                isClearable={false}
                            />
                        </div>

                        {/* Editable Fields */}
                        <div className="form-group">
                            <label htmlFor="transit_days" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>Transit Days <span style={{color: "red"}}>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                id="transit_days"
                                name="transit_days"
                                value={editFormData.transit_days}
                                onChange={(e) => handleEditInputChange("transit_days", e.target.value)}
                                placeholder="Enter Transit Days"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                }}
                                required
                                min="0"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="packaging_days" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>Packaging Days <span style={{color: "red"}}>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                id="packaging_days"
                                name="packaging_days"
                                value={editFormData.packaging_days}
                                onChange={(e) => handleEditInputChange("packaging_days", e.target.value)}
                                placeholder="Enter Packaging Days"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                }}
                                required
                                min="0"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="qc_hold_days" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>QC Hold Days <span style={{color: "red"}}>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                id="qc_hold_days"
                                name="qc_hold_days"
                                value={editFormData.qc_hold_days}
                                onChange={(e) => handleEditInputChange("qc_hold_days", e.target.value)}
                                placeholder="Enter QC Hold Days"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                }}
                                required
                                min="0"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="production_cycle_days" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>Production Cycle Days <span style={{color: "red"}}>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                id="production_cycle_days"
                                name="production_cycle_days"
                                value={editFormData.production_cycle_days}
                                onChange={(e) => handleEditInputChange("production_cycle_days", e.target.value)}
                                placeholder="Enter Production Cycle Days"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                }}
                                required
                                min="0"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="replenishment_cycle_days" style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}>Replenishment Cycle Days <span style={{color: "red"}}>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                id="replenishment_cycle_days"
                                name="replenishment_cycle_days"
                                value={editFormData.replenishment_cycle_days}
                                onChange={(e) => handleEditInputChange("replenishment_cycle_days", e.target.value)}
                                placeholder="Enter Replenishment Cycle Days"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                }}
                                required
                                min="0"
                            />
                        </div>
                        <div className="form-group">
                        <label
                            htmlFor="norm_days"
                            style={{
                                fontSize: "0.9rem",
                                fontWeight: "bold",
                                color: "#333",
                                marginBottom: "5px",
                                display: "block"
                            }}
                        >
                            Norm Days <span style={{ color: "red" }}>*</span>
                        </label>

                        <input
                            type="number"
                            className="form-control"
                            id="norm_days"
                            name="norm_days"
                            value={editFormData.norm_days}
                            onChange={(e) =>
                                handleEditInputChange("norm_days", e.target.value)
                            }
                            placeholder="Enter Norm Days"
                            style={{
                                width: "100%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                fontSize: "0.9rem"
                            }}
                            required
                            min="0"
                        />
                    </div>

                        {/* Update Button */}
                        <div style={{ 
                            textAlign: "right", 
                            marginTop: "20px",
                            marginBottom: "20px",
                            bottom: "0",
                            backgroundColor: "#fff",
                            padding: "10px 0",
                            borderTop: "1px solid #eee"
                        }}>
                            <button
                                type="submit"
                                id="sample-download-button"
                                style={{
                                    backgroundColor: "#93385D",
                                    color: "#fff",
                                    padding: "10px 30px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    fontSize: "0.9rem",
                                    fontWeight: "bold"
                                }}
                            >
                                Update
                            </button>
                        </div>
                    </form>
                )}

                {/* Upload Slider */}
                {sliderType === 2 && (
                    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding: 5 }}>
                        <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
                            <div className="d-flex justify-content-end mb-10p">
                                <button
                                    id="sample-download-button"
                                    onClick={downloadExcelTemplate}
                                    style={{
                                        padding: "8px 16px",
                                        backgroundColor: "#93385D",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontSize: "0.8rem"
                                    }}
                                >
                                    {"Download Sample Template"}
                                </button>
                            </div>
                            <input
                                type="file"
                                accept=".csv,.xlsx,.xls"
                                onChange={handleFileChange}
                                style={{
                                    border: "1px solid lightgrey",
                                    width: "100%",
                                    padding: "8px",
                                    borderRadius: "5px",
                                    backgroundColor: "#f9f9f9",
                                    color: "#000",
                                    fontSize: "13px",
                                }}
                                value={file}
                                id="bulkUploadFile"
                            />
                            <p style={{ color: "red", fontSize: "13px", margin: "0px", marginTop: "10px" }}>
                                *Accept .csv & .xlsx files only
                            </p>
                            <div style={{ textAlign: "right", marginTop: "10px" }}>
                                <button
                                    style={{ 
                                        backgroundColor: "#93385D", 
                                        color: "#fff", 
                                        fontSize: "0.8rem",
                                        padding: "8px 20px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer"
                                    }}
                                    onClick={(e) => {
                                        setLoadshow("show-m");
                                        setOverlayBlock("show-m");
                                        onClickingFileSubmit(e);
                                    }}
                                >
                                    {"Submit"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
            <div className={`overlay-block ${overlayBlock}`}></div>
            <div className={`overly-block ${overlyBlock}`} onClick={hideOverlySlideBlock}></div>
        </>
    );
};

// Styles
const selectStyles = {
    control: (base) => ({
        ...base,
        padding: '1px',
        borderRadius: '5px',
        border: '1px solid #d9d9d9',
        minHeight: '38px'
    }),
    singleValue: (base) => ({
        ...base,
        fontWeight: 'normal',
        color: '#333',
        fontSize: "12px"
    }),
    option: (base, state) => ({
        ...base,
        fontSize: "13px",
        fontWeight: state.isSelected ? 'normal' : 'normal',
    })
};

const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
    padding: "8px 20px",
    backgroundColor: "#93385D",
    color: "#fff",
    fontFamily: "sans-serif",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "0.8rem",
    fontWeight: "bold",
};

export default WarehouseLane;